import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import badgeKeys from './queryKeys';
function useFetchBadgeImagePlaylists(_ref) {
  var id = _ref.id,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  var queryKey = badgeKeys.badgeImagePlaylists(id);
  function queryFn() {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$api, badgeImagePlaylists;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return api('get', "/api/badges/images/".concat(id, "/playlists"), null);
          case 1:
            _yield$api = _context.sent;
            badgeImagePlaylists = _yield$api.badgeImagePlaylists;
            return _context.abrupt("return", badgeImagePlaylists);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var _useQuery = useQuery(_objectSpread({
      queryKey: queryKey,
      queryFn: queryFn
    }, queryOptions)),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? [] : _useQuery$data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    items: data
  }, result);
}
export default useFetchBadgeImagePlaylists;